import { LISTING_MODAL_HISTORY_ENTRY } from './constants';
import { setOffersFetchingMode } from './setOffersFetchingMode';
import { toggleModalAction } from './toggleModalAction';
import { EListingModalMode, EOffersFetchingMode } from './types';
import { TThunkAction } from '../../types/redux';
import { backFromModalHistoryEntry, hasModalHistoryEntry } from '../../utils/modalHistory';
import { resetListingOffers } from '../listingOffers/resetListingOffers';

export const closeMobileListing = (): TThunkAction => (dispatch, getState) => {
  if (!getState().listingModal.open) {
    return;
  }

  // Раскрытый листинг с записью в history: закрываем шагом назад, закроет «назад» записи (сюда же, уже без записи)
  if (hasModalHistoryEntry(LISTING_MODAL_HISTORY_ENTRY)) {
    void backFromModalHistoryEntry(LISTING_MODAL_HISTORY_ENTRY);

    return;
  }

  dispatch(toggleModalAction({ open: false, mode: EListingModalMode.UNSET }));
  dispatch(resetListingOffers());
  dispatch(setOffersFetchingMode(EOffersFetchingMode.NONE));
};
